export default __webpack_public_path__ + "static/media/26.bd5da090.jpg";